<usimweb-progress-spinner class="spinner" *ngIf="projects.length === 0" [value]="50"></usimweb-progress-spinner>

<usimweb-dropdown
  *ngIf="projects.length > 0"
  [values]="projects"
  key="uuid"
  value="name"
  placeholder="Select project"
  (selectionChange)="selectedProject($event)"
></usimweb-dropdown>
